import swal from "sweetalert2";
import { fetch } from "src/services/apollo-fetch";
import { Query } from "./_api";

export default {
    showRequestDeliveryModal({ commit }) {
        commit("setShowRequestDeliveryModal", true);
    },
    hideRequestDeliveryModal({ commit }) {
        commit("setShowRequestDeliveryModal", false);
    },
    cancelDeliveryRequest({ commit, dispatch }) {
        commit("setPendingReceiptLogs", []);
        dispatch("setRequestDeliveryType", null);
    },
    // deliveryRequest or willCall?
    setRequestDeliveryType({ commit }, deliveryType) {
        commit("setRequestDeliveryType", deliveryType);
    },
    async addToPendingReceiptLogs(
        { state, commit, dispatch },
        { receiptLogs },
    ) {
        const newLogs = [...state.pendingReceiptLogs, ...receiptLogs];
        const { size } = new Set(newLogs.map((log) => log.customer.id));
        if (size > 1) {
            swal({
                title: "Error!",
                text: "You may not select items for delivery from more than one customer at a time.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
            });
            return;
        }

        if (state.requestDeliveryType === null) {
            const { value, dismiss } = await swal({
                title: "Choose Request Type",
                allowEscapeKey: true,
                allowOutsideClick: true,
                showConfirmButton: true,
                confirmButtonText: "Delivery Request",
                confirmButtonColor: "#7B1A19",
                showCancelButton: true,
                cancelButtonText: "Will Call",
                cancelButtonColor: "#3085d6",
                type: "question",
                html: `
        <div class="col-12">Is this a <strong>delivery request</strong> or a <strong>will call</strong>?</div>
        `,
            });
            if (dismiss && dismiss !== "cancel") return;
            if (value) {
                dispatch("setRequestDeliveryType", "deliveryRequest");
            } else {
                dispatch("setRequestDeliveryType", "willCall");
            }
        }

        state.pendingReceiptLogs.forEach((pendingLog) => {
            receiptLogs.forEach((log, idx) => {
                // found a match with an existing receipt log
                // let's try to merge it
                if (pendingLog.id === log.id) {
                    if (log.units) {
                        log.units.forEach((unit) => {
                            const index = pendingLog.units.findIndex(
                                (pendingUnit) =>
                                    pendingUnit.unitId === unit.unitId,
                            );
                            // unit is not present, so let's add it, else we ignore and keep existing unit
                            if (index === -1) {
                                dispatch("setPendingReceiptLog", {
                                    ...pendingLog,
                                    units: [...pendingLog.units, unit],
                                });
                            }
                        });
                    } else {
                        // erase units, so it may be populated with all units
                        // perhaps a single unit was selected, but now the user
                        // has decided to select the whole receipt log instead of a single unit
                        dispatch("setPendingReceiptLog", {
                            ...pendingLog,
                            units: [],
                        });
                    }
                    // remove the receipt log now that its units have been merged
                    // to avoid duplicates
                    receiptLogs.splice(idx, 1);
                }
            });
        });
        await Promise.all(
            receiptLogs.map(async (log) => {
                // if there are no units, we need to fetch them
                if (!log.units) {
                    // eslint-disable-next-line no-underscore-dangle
                    log.units = await dispatch("fetchReceiptLogUnits", {
                        receiptLogId: log.id,
                    });
                }
            }),
        );
        dispatch("showRequestDeliveryModal");
        commit("addToPendingReceiptLogs", receiptLogs);
    },
    async fetchReceiptLogUnits(context, { receiptLogId }) {
        const response = await fetch.query({
            query: Query.receiptLogUnits,
            variables: { receiptLogId },
        });
        return response.data.receiptLogUnits;
    },
    setPendingReceiptLog({ commit }, receiptLog) {
        commit("setPendingReceiptLog", receiptLog);
    },
};
